<template>
  <div class="pt-37.5 px-23.5 flex flex-col slide">
    <h4 class="fz-301  mb-7.5 flex-shrink-0" style="color: #6e758d">
      {{ text.what }}
    </h4>
    <div class="services grid grid-cols-2 grid-rows-3 gap-5">
      <serviceWrapper image="loader" :title="text.services[0].title">
        <div class="flex flex-col items-end gap-1.25">
          <div class="flex gap-5 items-center service-items">
            <p class="text-left service-item " style="line-height: 1.5rem;">
              {{ text.services[0].points[0] }}
            </p>
            <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
            />
          </div>
          <div class="flex gap-5 items-center service-items">
            <p class="text-left service-item " style="line-height: 1.5rem;">
              {{ text.services[0].points[1] }}
            </p>
            <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
            />
          </div>
          <div class="flex gap-5 items-center service-items">
            <p class="text-left service-item " style="line-height: 1.5rem;">
              {{ text.services[0].points[2] }}
            </p>
            <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
            />
          </div>

        </div>
      </serviceWrapper>

      <serviceWrapper image="globe" :title="text.services[1].title">
        <div class="flex flex-col items-end gap-1.25">
          <div class="flex gap-5 items-center service-items">
            <p class="text-left service-item " style="line-height: 1.5rem;">
              {{ text.services[1].points[0] }}
            </p>
            <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
            />
          </div>
          <div class="flex gap-5 items-center service-items">
            <p class="text-left service-item " style="line-height: 1.5rem;">
              {{ text.services[1].points[1] }}
            </p>
            <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
            />
          </div>
          <div class="flex gap-5 items-center service-items">
            <p class="text-left service-item " style="line-height: 1.5rem;">
              {{ text.services[1].points[2] }}
            </p>
            <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
            />
          </div>

        </div>
      </serviceWrapper>

      <serviceWrapper image="radio" :title="text.services[2].title">
        <div class="flex flex-col items-end gap-1.25">
          <div class="flex gap-5 items-center service-items">
            <p class="text-left service-item " style="line-height: 1.5rem;">
              {{ text.services[2].points[0] }}
            </p>
            <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
            />
          </div>
          <div class="flex gap-5 items-center service-items">
            <p class="text-left service-item " style="line-height: 1.5rem;">
              {{ text.services[2].points[1] }}
            </p>
            <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
            />
          </div>
          <div class="flex gap-5 items-center service-items">
            <p class="text-left service-item " style="line-height: 1.5rem;">
              {{ text.services[2].points[2] }}
            </p>
            <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
            />
          </div>

        </div>
      </serviceWrapper>

      <serviceWrapper image="pen-tool" :title="text.services[3].title">
        <div class="flex flex-col items-end gap-1.25">
          <div class="flex gap-5 items-center service-items">
            <p class="text-left service-item " style="line-height: 1.5rem;">
              {{ text.services[3].points[0] }}
            </p>
            <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
            />
          </div>
          <div class="flex gap-5 items-center service-items">
            <p class="text-left service-item " style="line-height: 1.5rem;">
              {{ text.services[3].points[1] }}
            </p>
            <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
            />
          </div>
          <div class="flex gap-5 items-center service-items">
            <p class="text-left service-item " style="line-height: 1.5rem;">
              {{ text.services[3].points[2] }}
            </p>
            <img
              src="@/assets/images/slide_1/service_icons/cross.svg"
              class="inline w-5"
              alt=""
            />
          </div>

        </div>
      </serviceWrapper>

      <serviceWrapper image="smile" :title="text.services[4].title">
        <div class="flex flex-col mt-auto w-50 ml-auto">
          <p style="line-height: 1.5rem; text-align: right">{{ text.services[4].points[0] }} {{ text.services[4].points[1] }}</p>

        </div>
      </serviceWrapper>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import serviceWrapper from "../slide1/serviceWrapper";

export default {
  name: "agencySlide4",
  components:{serviceWrapper},
  computed: {
    text() {
      return require("@/assets/text/agency/slide4/" + this.lang + ".json");
    },
    ...mapState(['lang'])
  },
};
</script>

<style scoped></style>
